module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-header"
  }, [_c('div', {
    staticClass: "arrowDiv shrink-on-active",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-chap",
    class: {
      disabled: !_vm.prev
    },
    attrs: {
      "src": require(("../../assets/svg/arrow-" + (_vm.ltr ? 'next' : 'back') + ".svg")).default
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "arrowDiv shrink-on-active",
    on: {
      "click": _vm.nextChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-chap",
    class: {
      disabled: !_vm.next
    },
    attrs: {
      "src": require(("../../assets/svg/arrow-" + (_vm.ltr ? 'back' : 'next') + ".svg")).default
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ae0dab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter/chapter-header.vue
// module id = 299
// module chunks = 0 5 6